import React from 'react';
import { Star, MapPin } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Avis Clients</h2>
          <div className="flex items-center justify-center gap-2">
            <div className="flex">
              <Star className="w-6 h-6 text-orange-400 fill-orange-400" />
              <Star className="w-6 h-6 text-orange-400 fill-orange-400" />
              <Star className="w-6 h-6 text-orange-400 fill-orange-400" />
              <Star className="w-6 h-6 text-orange-400 fill-orange-400" />
              <Star className="w-6 h-6 text-orange-400 fill-orange-400" />
            </div>
            <span className="text-lg font-semibold text-gray-900">4.9/5</span>
            <span className="text-gray-500">(247 avis)</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-2xl p-6">
            <div className="flex gap-1 mb-4">
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
            </div>
            <p className="text-gray-700 mb-4">"Service impeccable pour notre mariage à Étretat. Le chapiteau était magnifique et l'équipe très professionnelle. Je recommande vivement !"</p>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-semibold text-gray-900">Marie D.</div>
                <div className="text-sm text-gray-500 flex items-center gap-1"><MapPin className="w-3 h-3" /> Le Havre</div>
              </div>
              <span className="text-xs text-gray-400">Il y a 2 semaines</span>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6">
            <div className="flex gap-1 mb-4">
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
            </div>
            <p className="text-gray-700 mb-4">"Excellent rapport qualité-prix pour notre événement d'entreprise. Livraison ponctuelle et installation rapide. Parfait !"</p>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-semibold text-gray-900">Jean-Pierre L.</div>
                <div className="text-sm text-gray-500 flex items-center gap-1"><MapPin className="w-3 h-3" /> Rouen</div>
              </div>
              <span className="text-xs text-gray-400">Il y a 1 mois</span>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6">
            <div className="flex gap-1 mb-4">
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
              <Star className="w-5 h-5 text-orange-400 fill-orange-400" />
            </div>
            <p className="text-gray-700 mb-4">"Je recommande vivement ! Très réactifs et à l'écoute de nos besoins. Le pack tout inclus nous a simplifié la vie."</p>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-semibold text-gray-900">Sophie M.</div>
                <div className="text-sm text-gray-500 flex items-center gap-1"><MapPin className="w-3 h-3" /> Honfleur</div>
              </div>
              <span className="text-xs text-gray-400">Il y a 3 semaines</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
